import { SkeletonText, Skeleton, SkeletonButton } from '@dev-spendesk/grapes';

import { HeaderWithNavigation } from 'src/core/common/components/HeaderWithNavigation/HeaderWithNavigation';

/**
 * Card-like skeleton representing a budget group (e.g. Product, Sales, Marketing).
 */
const BudgetCardSkeleton = ({ rows = 3 }: { rows?: number }) => {
  return (
    <div className="box my-24 p-24">
      {/* Table header */}
      <div className="grid grid-cols-5 gap-16 pb-24">
        <SkeletonText width="120px" size="xl" />
        <SkeletonText width="120px" size="xl" />
      </div>

      {/* Placeholder rows */}
      {Array.from({ length: rows }).map(() => (
        <div
          key={`skeleton-row-${Math.random()}`}
          className="grid grid-cols-5 items-center gap-16 py-12"
        >
          {/* Budget name */}
          <SkeletonText width="120px" size="xl" />

          {/* Utilisation bar + figure */}
          <div className="flex items-center gap-8">
            <Skeleton width="160px" height="8px" />
            <SkeletonText width="60px" size="m" />
          </div>

          {/* Budget amount */}
          <SkeletonText width="100px" size="xl" />

          {/* Committed */}
          <SkeletonText width="80px" size="xl" />

          {/* Available */}
          <SkeletonText width="80px" size="xl" />
        </div>
      ))}
    </div>
  );
};

/**
 * Full‐page skeleton for the Budgetary Exercises page.
 * Mirrors the structure visible in the design: header, filters/actions and four budget cards.
 */
export const BudgetaryExercisesPageSkeleton = () => {
  return (
    <div className="page__container">
      {/* Top navigation header */}
      <HeaderWithNavigation
        links={[]}
        rightContent={
          <div className="flex items-center gap-16">
            {/* Year dropdown */}
            <SkeletonText width="70px" size="xl" />
            {/* Date range pill */}
            <SkeletonText width="180px" size="xl" />
            {/* Status pill */}
            <SkeletonText width="100px" size="xl" />
          </div>
        }
      >
        {/* Page title */}
        <SkeletonText width="140px" size="xxl" />
      </HeaderWithNavigation>

      {/* Main content */}
      <div className="flex w-full flex-col self-center p-40 pt-16">
        {/* Filter & action buttons */}
        <div className="flex w-full items-center justify-between pt-16">
          {/* Global filter */}
          <SkeletonButton width="100px" />

          {/* Actions: export + kebab */}
          <div className="flex gap-8">
            <SkeletonButton width="40px" />
            <SkeletonButton width="40px" />
          </div>
        </div>

        {/* Budget sections (accordions) */}
        <BudgetCardSkeleton rows={3} />
        <BudgetCardSkeleton rows={1} />
        <BudgetCardSkeleton rows={1} />
        <BudgetCardSkeleton rows={1} />
      </div>
    </div>
  );
};
